import { produce } from 'immer';
import { RemoteRecordData } from 'b2b-apps/shop/common/redux/RemoteRecordData';
import {
  DOWNLOAD_PRODUCT_PDF,
  DOWNLOAD_PRODUCT_PDF_FULFILLED,
  DOWNLOAD_PRODUCT_PDF_REJECTED,
  PRINT_PRODUCT_PDF,
  PRINT_PRODUCT_PDF_FULFILLED,
  PRINT_PRODUCT_PDF_REJECTED,
} from 'b2b-apps/shop/product/redux/productPdf/actionTypes';
import {
  ProductPdfActions,
  ProductPdfState,
} from 'b2b-apps/shop/product/redux/productPdf/types';
const initialState = {};

const reducer = (
  state: ProductPdfState = initialState,
  action: ProductPdfActions,
): ProductPdfState => {
  switch (action.type) {
    case DOWNLOAD_PRODUCT_PDF: {
      return produce(state, (draft: ProductPdfState) => {
        draft.download = RemoteRecordData.init();
      });
    }

    case DOWNLOAD_PRODUCT_PDF_FULFILLED:
      return produce(state, (draft: ProductPdfState) => {
        draft.download = RemoteRecordData.fulfill({});
      });

    case DOWNLOAD_PRODUCT_PDF_REJECTED:
      return produce(state, (draft: ProductPdfState) => {
        draft.download = RemoteRecordData.reject(action.payload.error);
      });

    case PRINT_PRODUCT_PDF:
      return produce(state, (draft: ProductPdfState) => {
        draft.print = RemoteRecordData.init();
      });

    case PRINT_PRODUCT_PDF_FULFILLED:
      return produce(state, (draft: ProductPdfState) => {
        draft.print = RemoteRecordData.fulfill({});
      });

    case PRINT_PRODUCT_PDF_REJECTED:
      return produce(state, (draft: ProductPdfState) => {
        draft.print = RemoteRecordData.reject(action.payload.error);
      });

    default:
      return state;
  }
};

export { reducer };
